import axios from "axios";
import { environment } from "../../environment";

export interface HelpItem {
  Id?: string;
  Title__c: string;
  Description__c?: string;
  Type__c: 'PDF' | 'Video';
  URL__c?: string;
  Order__c?: number;
  CreatedDate?: string;
  LastModifiedDate?: string;
}

export interface HelpApiResponse {
  success: boolean;
  data?: HelpItem | HelpItem[];
  message?: string;
  error?: string;
}

class HelpService {
  private baseUrl = environment.contentUrl + "help";

  async getAll(): Promise<HelpItem[]> {
    try {
      const res = await axios.get(this.baseUrl);
      if (res?.data?.success && res?.data?.data) {
        return Array.isArray(res.data.data) ? res.data.data : [res.data.data];
      } else {
        throw new Error(res?.data?.error || "Failed to fetch help items");
      }
    } catch (err) {
      console.error("Error fetching help items:", err);
      throw err;
    }
  }

  async getById(id: string): Promise<HelpItem> {
    try {
      const res = await axios.get(`${this.baseUrl}/${id}`);
      if (res?.data?.success && res?.data?.data) {
        return res.data.data;
      } else {
        throw new Error(res?.data?.error || "Failed to fetch help item");
      }
    } catch (err) {
      console.error(`Error fetching help item ${id}:`, err);
      throw err;
    }
  }
}

export default new HelpService() as HelpService;